module.exports = __webpack_public_path__ + "static/media/ph.4e44ea60.svg";